import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import AccountContactReportCtrl from '../../../components/reportsComponents/accountmanagement/accountContactReportCtrl';
import AccountContactReportTable from '../../../components/reportsComponents/accountmanagement/accountContactReportTable';
const pageTitle = 'Account Contact Report'
let AccountContactReportForm={
	formAccountContactReportInfo:{}
}

class AccountContactReport extends Component {
	constructor() {
		super();
		this.state = {
            asOfDate:''
		}
	}
	componentWillMount = () => {
		document.title = pageTitle;
		
    }
    onAccountContactFieldChange=(key, value)=>{
        this.setState({[key]:value});
    }
	render() {
		return (
            <Fragment>
                <div className="page-header">
                    <div className="row mb-10">
                        <div className="col-md-12 col-sm-12">
                            <div className="title">
                                <h4> Account Contact Report</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pd-10 bg-white border-radius-4 box-shadow">
                    <AccountContactReportCtrl onAccountContactFieldChange={(key, value)=>this.onAccountContactFieldChange(key, value)}
                    initCallBack={(frm)=>{
						AccountContactReportForm.formAccountContactReportInfo=frm;
                    }} asofdate={this.state.asOfDate}/>
                    <AccountContactReportTable />
                </div>
            </Fragment>
		);
	}
}
const mapStateToProps = (state, ownProps) => {
	return {
		
	}
};

export default withRouter(connect(mapStateToProps)(AccountContactReport));
